import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { VecinosSeguridadComponent } from './listado/vecinos-seguridad.component';

const routes: Routes = [
  { path: '', redirectTo: 'listado', pathMatch: 'full' },
  { path: 'listado', title: 'Vecinos', component: VecinosSeguridadComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class VecinosSeguridadRoutingModule {}
